class MultipleUpdater extends HTMLElement {
  #abortController
  #numAllowed
  #total
  #activeUpdaters

  constructor() {
    super();
    this.numberBtn = this.querySelector('number-button');
  }

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    setTimeout(() => {
      this.numberBtn.input.addEventListener('input', (e) => {
        if (e.target.valueAsNumber === 0) {
          this.previousElementSibling.click();
        } else {
          this.dataset.quantity = e.target.value;
        }
      }, { signal });
      //
      this.previousElementSibling.querySelector('input').addEventListener('input', (e) => {
        if(e.target.checked) {
          this.#setTotal();
          if (this.#total === this.#numAllowed) {
            this.dataset.quantity = 0;
          } else {
            this.numberBtn.dataset.value = 1;
            this.dataset.quantity = 1;
          }
        }
      }, { signal })
    }, 0);
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return ['data-quantity', 'data-max', 'data-num-allowed'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-quantity') {
      setTimeout(() => {
        this.#setMaximums();
      },0);
    }
    //
    if (name === 'data-max') {
      this.numberBtn.input.setAttribute('max', newValue);
    }
    //
    if (name === 'data-num-allowed') {
      setTimeout(() => {
        this.#numAllowed = parseInt(newValue);
      },0);
    }
  }

  #setMaximums() {
    this.#setTotal();
    const remaining = this.#numAllowed - this.#total;
    this.#activeUpdaters.forEach(el => el.dataset.max = el.numberBtn.input.valueAsNumber + remaining);
  }

  #setTotal() {
    this.#activeUpdaters = Array.from(this.numberBtn.input.form.querySelectorAll('multiple-updater')).filter(el => el.clientHeight);
    this.#total = this.#activeUpdaters.map(el => el.numberBtn.input.valueAsNumber).reduce((a,b) => a + b, 0);
  }
}

customElements.define('multiple-updater', MultipleUpdater);